import {createApi} from '@reduxjs/toolkit/query/react'
import {getSeoApiUrl} from 'utils/apiUrls'

import {fetchBaseQuery} from '@vio/core/src/utils/network/fetchBaseQuery'

interface TranslateParams {
  hotelId: string
  lang: string
}

const API_URL = getSeoApiUrl()

export const translateReviewsApi = createApi({
  reducerPath: 'translateReviewsApi',
  baseQuery: fetchBaseQuery({baseUrl: API_URL}),
  endpoints: builder => ({
    translateReviews: builder.query<Record<string, string>, TranslateParams>({
      query: ({hotelId, lang}) => ({
        url: '/translate-reviews',
        method: 'GET',
        params: {hotelId, lang}
      })
    })
  })
})

export const {useTranslateReviewsQuery} = translateReviewsApi
